import { useState } from "react";
import Modal from "../../../../components/lib/modal";
import ConfirmCloseView from "../../../customers/components/confirmCloseView";
import AssetsService from "../../../../rest/assetsService";
import { toast } from "react-toastify";
import ComboRegisterStepper from "./comboRegisterStepper";
import ComboService from "../../../../rest/comboService";

const ComboRegisterModal = ({ isOpen, setIsOpen }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };

    const handleFinish = async ({ combo, nutrition, image }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            let imageUrl = null;

            if (image) {
                const formData = new FormData();
                formData.append("file", image);
                const upload = await AssetsService.uploadProductImage(formData);
                imageUrl = upload.data;
            }

            await ComboService.registerCombo({
                ...combo,
                nutritionalFacts: JSON.stringify(nutrition),
                imageUrl,
                client_code: sessionStorage.getItem("clientCode"),
            });

            toast.success("Combo cadastrado com sucesso!");
            setIsOpen(false);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao cadastrar combo.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Cadastrar Combo"
            hideFooter
            maxWidth="max-w-xl lg:max-w-2xl md:-mr-16"
        >
            <div className="relative h-full flex flex-col">
                <ComboRegisterStepper
                    onDirty={() => setHasData(true)}
                    onCancel={requestClose}
                    onFinish={handleFinish}
                    isSubmitting={isSubmitting}
                />

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm p-4 rounded-lg">
                        <ConfirmCloseView
                            onCancel={() => setConfirmClose(false)}
                            onConfirm={forceClose}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ComboRegisterModal;